import React from 'react';
import styled from 'styled-components';
import Select from 'react-select';

const StyledSelect = styled(Select)`
  font: 14px dinpro-regular;
  border: 1px solid rgba(0, 153, 255, 0.2);
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0 10px 20px -10px rgba(0, 153, 255, 0.1);

  flex: 1;
  z-index: 5;
  & .Select-control {
    border: none;
    height: 48px;
    .Select-value {
      line-height: 48px;
      padding-left: 16px;
      padding-right: 10px;
    }
  }
  & .Select-menu-outer {
    max-height: 510px !important;
  }
  & .Select-menu {
    max-height: 508px !important;
  }
`;

const SelectWithStyles = props => <StyledSelect {...props} />;

export default SelectWithStyles;
